import { lazy, Suspense } from 'react';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import Navbar from '@/components/Navbar';
import HeroSection from '@/components/HeroSection';
import CompanyOverview from '@/components/CompanyOverview';

const MobileOfficeSolutions = lazy(() => import('@/components/MobileOfficeSolutions'));
const ResidentialHousing = lazy(() => import('@/components/ResidentialHousing'));
const DeploymentSudan = lazy(() => import('@/components/DeploymentSudan'));
const LogisticsSupplyChain = lazy(() => import('@/components/LogisticsSupplyChain'));
const SustainabilitySection = lazy(() => import('@/components/SustainabilitySection'));
const CladdingSection = lazy(() => import('@/components/CladdingSection'));
const DesignBuildProcess = lazy(() => import('@/components/DesignBuildProcess'));
const WhyKaizen = lazy(() => import('@/components/WhyKaizen'));
const ContactSection = lazy(() => import('@/components/ContactSection'));
const Footer = lazy(() => import('@/components/Footer'));

const SectionFallback = () => <div className="min-h-[200px]" />;

const Index = () => {
  const scrollRef = useScrollAnimation();

  return (
    <div ref={scrollRef}>
      <Navbar />
      <HeroSection />
      <CompanyOverview />
      <Suspense fallback={<SectionFallback />}>
        <MobileOfficeSolutions />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <ResidentialHousing />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <DeploymentSudan />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <LogisticsSupplyChain />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <SustainabilitySection />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <CladdingSection />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <DesignBuildProcess />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <WhyKaizen />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <ContactSection />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
